import config from '../../../config/config';
import getRequest from '../base/get';
import patchRequest from '../base/patch';
import postRequest from '../base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}
export default {
  /**
   * Get the profile details in api function
   * @returns {any} A promise that resolves with the profile details
   */
  getProfileDetails: (): Promise<any> => {
    return getRequest(`${config.cpo.accountApiUrl}api/partner/v1/users/profile`);
  },
  /**
   * Get the total charging station function
   * @returns {any} A promise that resolves with the total charging station count
   */
  getTotalChargingStation: (): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/total-charging-stations`,
    );
  },
  /**
   * Get the total charging station function
   * @returns {any} A promise that resolves with the total charging points count
   */
  getTotalChargingPoints: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-charging-points`);
  },
  /**
   * Get the total charging station function
   * @returns {any} A promise that resolves with the total connectors count
   */
  getTotalConnectors: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-connectors`);
  },
  /**
   * Get revenue history
   */
  getRevenueHistory: (): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/cs-revenue-growth-month-wise`,
    );
  },
  /**
   * Get total balance
   */
  getTotalWalletBalance: (): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/facility/v1/charging-transaction/total-revenue`);
  },
  /**
   * Create the role api call function
   * @param {any} data - The payout creation data
   * @returns {any} A promise that resolves with the payout creation status
   */
  createPayout: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.cpo.accountApiUrl}api/partner/v1/account/create-stripe`, {
      ...parameters,
    });
  },
  /**
   * Get the get Stripe Settings
   * @returns {any} A promise that resolves with the Stripe settings
   */
  getStripeSettings: (): Promise<any> => {
    return getRequest(`${config.cpo.accountApiUrl}api/partner/v1/account/get-stripe-settings`);
  },
  /**
   * Update the update Payout
   * @param {any} data - The payout preference update data
   * @returns {any} A promise that resolves with the payout preference update response
   */
  updatePayout: (data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.cpo.accountApiUrl}api/partner/v1/account/update-payout-preference`, {
      ...parameters,
    });
  },
  /**
   * Update the update Payout Enabled
   * @param {any} data - The payout ability update data
   * @returns {any} A promise that resolves with the payout ability update response
   */
  updatePayoutEnabled: (data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.cpo.accountApiUrl}api/partner/v1/account/update-payout-ability`, {
      ...parameters,
    });
  },

  /**
   * Fetch transaction by Id
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the revenue payout
   */
  fetchRevenuePayout: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/facility/v1/revenue-payout`, {
      ...parameters,
    });
  },
  /**
   * get for the Revenue Payout  Total
   */
  getRevenuePayoutAmount: (): Promise<any> => {
    return getRequest(
      `${config.transactionApiUrl}api/facility/v1/revenue-payout/transferred-total`,
    );
  },
  /**
   * Fetch Revenue getStripeHistoryExport API for export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  getStripeHistoryExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/facility/v1/revenue-payout/export-data`, {
      ...parameters,
    });
  },
};
